export default __webpack_public_path__ + "static/media/numpad.0673cadd.png";